import React from 'react';
import { Section } from './Section';
import { trackInitiateCheckout } from '../utils/metaPixel';
export const FinalCTA = () => {
  return <Section className="bg-brand-900 text-center pb-24 md:pb-32" data-id="element-94">
      <div className="max-w-3xl mx-auto" data-id="element-95">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-96">
          Empieza a cocinar para tu salud hoy mismo
        </h2>
        <p className="text-xl text-brand-100 mb-10" data-id="element-97">
          40 recetas riquísimas que cuidan tu tiroides. Sin riesgo. Acceso de
          por vida.
        </p>

        <div className="flex flex-col items-center justify-center gap-4 mb-8" data-id="element-98">
          <div className="text-brand-200 text-lg line-through" data-id="element-99">
            Antes: ARS $39.990
          </div>
          <div className="text-5xl font-black text-white mb-4" data-id="element-100">ARS $17.390</div>

          <button onClick={() => {
          trackInitiateCheckout({
            currency: 'ARS',
            value: 17390,
            content_ids: ['plan-tiroides-360']
          });
          document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="w-full sm:w-auto px-10 py-5 text-xl font-bold rounded-xl text-brand-900 bg-white hover:bg-stone-100 transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1" data-id="element-101">
            SÍ, QUIERO MIS RECETAS YA
          </button>
        </div>

        <p className="text-sm text-brand-300" data-id="element-102">
          Pago 100% seguro y encriptado. Entrega inmediata por email.
        </p>
      </div>
    </Section>;
};